import { PRIVATE_ROOT } from 'portal-modules/common/constants/urls'

export const APARTMENT = {
  ROOT: `${PRIVATE_ROOT}/apartment`,
}
